"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_router_1 = require("react-router");
const FluShots_1 = __importDefault(require("./components/fluShots/FluShots"));
const FollowUp_1 = __importDefault(require("./components/followUp/FollowUp"));
const CompletedTests_1 = __importDefault(require("./components/completedTests/CompletedTests"));
const Logout_1 = __importDefault(require("./components/Logout"));
const PersonProfile_1 = __importDefault(require("./components/search/PersonProfile"));
const SearchUser_1 = __importDefault(require("./model/SearchUser"));
const UserController_1 = __importDefault(require("./api/UserController"));
const mobx_react_1 = require("mobx-react");
const hui_1 = require("@mit/hui");
const ContactTracing_1 = __importDefault(require("./components/contactTracing/ContactTracing"));
const Vaccine_1 = __importDefault(require("./components/vaccine/Vaccine"));
const TimeManagement_1 = __importDefault(require("./components/timeManagement/TimeManagement"));
const PeopleController_1 = __importDefault(require("./api/PeopleController"));
const Home = ({ holds, history, peopleStore, covidNav }) => {
    const [isSearchLoading, setSearchLoading] = (0, react_1.useState)(false);
    const [searchData, setSearchData] = (0, react_1.useState)([]);
    const [timeout, setSearchTimeout] = (0, react_1.useState)(0);
    const handleSearch = (query, element) => {
        if (timeout) {
            clearTimeout(timeout);
        }
        if (query.length <= 0)
            return;
        if (element.key === 'Tab') {
            return;
        }
        if (element.keyCode === 8 || element.keyCode === 46)
            return;
        setSearchLoading(true);
        setSearchTimeout(setTimeout(() => {
            //CLOUD SEARCH (JUST UNCOMMENT)
            // cloudSearchController.search(query).then((results) => {
            // 	if (results.items) {
            // 		setSearchLoading(false);
            // 		let newSearchData = results.items.hits.hit.map((itm) => {
            // 			return {
            // 				icon: "user",
            // 				text: `${itm.fields.suggestion}`,
            // 				secondaryText: "",
            // 				tertiaryText: "",
            // 				id: itm.fields.krb_name,
            // 			};
            // 		});
            // 		setSearchData(newSearchData);
            // 		setSearchLoading(false);
            // 	}
            // });
            PeopleController_1.default.fetchPeopleAws(query).then((peopleResultsResponse) => {
                if (peopleResultsResponse.people) {
                    setSearchLoading(false);
                    let newSearchData = peopleResultsResponse.people.map((itm) => {
                        return {
                            icon: "user",
                            text: `${itm.displayName} (${itm.kerberosId})`,
                            secondaryText: "",
                            tertiaryText: "",
                            id: itm.kerberosId,
                        };
                    });
                    setSearchData(newSearchData);
                    setSearchLoading(false);
                }
            });
        }, 500));
    };
    const personSelected = (person) => __awaiter(void 0, void 0, void 0, function* () {
        if (person.id) {
            let profileResp = yield UserController_1.default.fetchProfile(person.id);
            if (profileResp.person) {
                holds.personHolds = undefined;
                SearchUser_1.default.person = Object.assign({ label: person }, profileResp.person);
                history.push(`/search?krb_name=${SearchUser_1.default.person.kerberosId}`);
                covidNav.activePage = "search";
            }
        }
    });
    const autoCompleteData = {
        name: "searchbox",
        onChange: personSelected,
        isBusy: isSearchLoading,
        items: searchData,
        type: "default",
        searchOptions: {
            startIcon: "search",
            startIconAccessibilityText: "search",
            placeholderText: "Search by name or kerberos id",
            type: hui_1.TextboxType.IconStart,
            name: "search",
        },
        showItemsOnFocus: false,
        onBlur: () => setSearchLoading(false),
        onSearch: handleSearch,
    };
    const getTitle = () => {
        let url = window.location.pathname;
        switch (url) {
            case "/":
            case "/folow-up":
            default:
                return "Follow-up Required";
            // case "/vaccine-hold":
            // 	return "Vaccine Holds";
            case "/search":
                return "Search";
            case "/completed-tests":
                return "Completed Tests";
            case "/time-management":
                return "Time Management";
            case "/flushots":
                return "Flushots";
            case "/vaccine":
                return "Vaccine";
            case "/contact-tracing":
                return "Covid Contact Tracing";
        }
    };
    return ((0, jsx_runtime_1.jsx)(hui_1.BasicLayout, { startState: true, autoComplete: autoCompleteData, fullWidth: true, content: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/contact-tracing" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default, peopleStore: peopleStore }, { children: (0, jsx_runtime_1.jsx)(ContactTracing_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/search" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default }, { children: (0, jsx_runtime_1.jsx)(PersonProfile_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/logout" }, { children: (0, jsx_runtime_1.jsx)(Logout_1.default, {}) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/follow-up" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default, peopleStore: peopleStore }, { children: (0, jsx_runtime_1.jsx)(FollowUp_1.default, { peopleStore: peopleStore, history: history }) })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/completed-tests" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default, peopleStore: peopleStore }, { children: (0, jsx_runtime_1.jsx)(CompletedTests_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/flushots" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default, peopleStore: peopleStore }, { children: (0, jsx_runtime_1.jsx)(FluShots_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/vaccine" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default, peopleStore: peopleStore, holds: holds }, { children: (0, jsx_runtime_1.jsx)(Vaccine_1.default, {}) })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/time-management" }, { children: (0, jsx_runtime_1.jsx)(TimeManagement_1.default, {}) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, Object.assign({ exact: true, path: "/" }, { children: (0, jsx_runtime_1.jsx)(mobx_react_1.Provider, Object.assign({ searchUser: SearchUser_1.default, peopleStore: peopleStore }, { children: (0, jsx_runtime_1.jsx)(FollowUp_1.default, {}) })) }))] }), contentTitle: getTitle() }));
};
const HomeWrapper = (0, react_router_1.withRouter)((0, mobx_react_1.inject)("peopleStore", "holds", "covidNav")((0, mobx_react_1.observer)(Home)));
exports.default = HomeWrapper;
